module.exports = __webpack_public_path__ + "img/rainbow.27e55ccd.png";